export enum FeaturePermission {
  // Letters
  GroupList = 'groupList',
  GroupItem = 'groupItem',
  SubmissionItem = 'submissionItem',
  SubmissionSample = 'submissionSample',
  SubmissionCommon = 'submissionCommon',
  SubmissionPrivate = 'submissionPrivate',
  TemplateEditor = 'templateEditor',
  // Answers
  AnswerTable = 'answerTable',
  AnswerItem = 'answerItem',
  // Management
  ManagementUsers = 'managementUsers',
  ManagementUnits = 'managementUnits',
  // Roles
  RolePermissions = 'rolePermissions',
  RoleItem = 'roleItem',
}
